module.exports = __webpack_public_path__ + "static/img/1.9e7ce85.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/sp/1.png
// module id = ROEO
// module chunks = 0